import { Api } from '@axiom/ui';
import type { AccountBenchResponse, Opportunity } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class AccountBenchApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readOpportunityBench({
    opportunityId,
  }: {
    opportunityId: Opportunity['id'];
  }) {
    return super.read<{ data: AccountBenchResponse }>({
      endpoint: `/opportunities/${opportunityId}/bench`,
      method: 'GET',
    });
  }

  async refreshOpportunityBench({
    opportunityId,
  }: {
    opportunityId: Opportunity['id'];
  }) {
    return super.invalidate(`/opportunities/${opportunityId}/bench`);
  }
}

export const AccountBenchApi = new AccountBenchApiClass();
